import LogoImg from "assets/images/png/logo.png";
import { Button, Card, localStorage, Spinner, ViewerContext } from "dash-ui";
import { RoutesPath } from "flow-components/routes/routes";
import { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export function SSOCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const { accessToken, refreshToken, refreshTokenExpiry } = {
    accessToken: searchParams.get("accessToken"),
    refreshToken: searchParams.get("refreshToken"),
    refreshTokenExpiry: searchParams.get("refreshTokenExpiry"),
  };

  const { account, setTokens } = useContext(ViewerContext);

  // update localStorage
  useEffect(() => {
    if (!accessToken || !refreshToken || !refreshTokenExpiry) return;

    localStorage.setAccessToken(accessToken);
    localStorage.setRefreshToken(refreshToken);
    localStorage.setRefreshTokenExpiry(refreshTokenExpiry);

    setTokens?.({
      accessToken,
      refreshToken,
      refreshTokenExpiry,
    });
  }, [accessToken, refreshToken, refreshTokenExpiry, setTokens]);

  // Redirect to properties page after account is present
  useEffect(() => {
    if (account) {
      navigate(RoutesPath.Properties);
    }
  }, [account]);

  return (
    <div className="w-full min-h-screen text-center flex justify-center items-center">
      <Card
        className="w-64 h-64 flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        gap={40}
      >
        <div className="flex flex-col justify-center">
          <img width={100} height={100} src={LogoImg} alt="Dash Logo" />
        </div>
        <div className="flex flex-col gap-2 justify-center items-center">
          {
            <div className="flex flex-row">
              <p className="mr-2">Redirecting...</p>
              <Spinner></Spinner>
            </div>
          }
          <div className="px-2 mt-4">
            <p className="text-xs italic">
              If you are not redirected within 5 seconds, please reload the
              page.
            </p>
          </div>
          <Button onClick={() => navigate(RoutesPath.Properties)} mt={4}>
            Go to Homepage
          </Button>
        </div>
      </Card>
    </div>
  );
}
